import { api } from './api';

const invoiceAddressGetList = async (customerId) => {
    const response = await api({
        url: `InvoiceAddresses/getList`,
        method: 'GET',
        params: {customerId},
    });
    return response.data;
};

const invoiceAddressUpdate = async (data) => {
    const response = await api({
        url: `InvoiceAddresses/update`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const invoiceAddressServices = {
  invoiceAddressGetList,
  invoiceAddressUpdate,
};

export default invoiceAddressServices;
